import ChoosePasswordFormContainer from './ChoosePasswordFormContainer';

export default ChoosePasswordFormContainer;
